module.exports = __webpack_public_path__ + "img/Flag_of_Colombia.53c6a000.svg";